const StationObservationList = () => import('Views/stationObservation/stationObservation-list-new-ui');

export default[
  { path: '/station-observation-list', component: StationObservationList },
  { path: '/station-observation-list/:id', component: StationObservationList },
];



// WEBPACK FOOTER //
// ./src/router/stationObservation.js